import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import * as Analytics from "./google-analytics-service";

import useAuthenticationContext from "@/services/context/authentication/use-authentication-context.ts";
import { useOptionalProjectContext } from "../project/use-project-context";

export default function GoogleAnalytics() {

    const initialized = useRef(false);

    const location = useLocation();

    const { authenticationResponse } = useAuthenticationContext();

    const projectContext = useOptionalProjectContext();
    const project = projectContext?.project;

    useEffect(() => {
        if (initialized.current) return;
        if (!import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID) return;

        initialized.current = true;

        Analytics.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID);
    }, []);

    useEffect(() => {
        Analytics.setUser({
            userId: authenticationResponse?.user?.id,
            company: authenticationResponse?.user?.organizationName
        });
    }, [authenticationResponse, authenticationResponse?.user?.id, authenticationResponse?.user?.organizationName]);

    useEffect(() => {
        Analytics.trackPage(location.pathname, {
            projectId: project?.id,
            projectName: project?.name
        });
    }, [location.pathname, project?.id, project?.name]);

    return null;
}